// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import {
    carouselFieldDefinitions,
    CarouselFieldProps,
    carouselFields,
    getExtendedCarouselStyles,
} from "@store/Framework/Common/Utilities/CarouselWidgetHelpers";
import { getContextualCssUnitField } from "@store/Framework/Common/Utilities/FieldHelpers";
import Carousel, { CarouselStyles } from "@store/Overrides/Components/Carousel";
import React, { useContext } from "react";
import { css } from "styled-components";

enum ownfields {
    numberOfItems = "numberOfItems",
    title = "title",
    maxVisibleSlides = "maxVisibleSlides",
    containerMaxWidth = "containerMaxWidth",
    viewportOffset = "viewportOffset",
}

const fields = { ...ownfields, ...carouselFields };

interface WidgetCarouselProps extends WidgetProps {
    fields: {
        [ownfields.title]: string;
        [ownfields.numberOfItems]: number;
        [ownfields.maxVisibleSlides]: number;
        [ownfields.containerMaxWidth]: string;
        [ownfields.viewportOffset]: string;
    } & CarouselFieldProps;
}
export const carouselWrapperStyle = {
    css: css`
        position: relative;
        overflow: hidden;
    `,
};
const WidgetCarousel: React.FC<WidgetCarouselProps> = ({
    id,
    fields: { title, numberOfItems, showDots, slideInterval, maxVisibleSlides, containerMaxWidth, viewportOffset },
    fields,
}) => {
    const { isEditing } = useContext(ShellContext);
    const extendedCarouselStyles: CarouselStyles = getExtendedCarouselStyles(fields, isEditing);
    const wrapperStyles = {
        css: css`
            ${carouselWrapperStyle.css}
            ${containerMaxWidth ? `max-width: ${containerMaxWidth};` : ""}
        `,
    };
    const zones = Array.from({ length: numberOfItems }, (_, index) => (
        <div key={`Content${index}`}>
            <Zone contentId={id} zoneName={`Content${index}`} />
        </div>
    ));

    const slides = zones.map((zone, index) => {
        return {
            id: index.toString(),
            renderComponent: () => <StyledWrapper>{zone}</StyledWrapper>,
        };
    });
    extendedCarouselStyles.carouselSlidesContainer = viewportOffset
        ? {
              css: css`
                  ${extendedCarouselStyles.carouselSlidesContainer?.css} width: calc(100% - ${viewportOffset});
              `,
          }
        : extendedCarouselStyles.carouselSlidesContainer;

    const showCarousel = slides.length > 1;

    if (!showCarousel) {
        return (
            <StyledWrapper
                css={css`
                    display: flex;
                    justify-content: space-between;
                `}
            >
                {zones.map((zone, index) => zone)}
            </StyledWrapper>
        );
    }
    return (
        <StyledWrapper {...wrapperStyles}>
            <Carousel
                extendedStyles={extendedCarouselStyles}
                id={id}
                slideInterval={slideInterval}
                showDots={showDots}
                maxNumberOfColumns={maxVisibleSlides}
                title={title}
                slides={slides}
            />
        </StyledWrapper>
    );
};

const viewportOffset = getContextualCssUnitField(fields.viewportOffset).definition;
const maxWidthContainerField = getContextualCssUnitField(fields.containerMaxWidth).definition;
const widgetModule: WidgetModule = {
    component: WidgetCarousel,
    definition: {
        group: "Common",
        displayName: "Widget Carousel",
        isSystem: true,
        icon: "Carousel",
        fieldDefinitions: [
            {
                displayName: "Container Max Width",
                ...maxWidthContainerField,
                defaultValue: "90vw",
            },
            {
                displayName: "Viewport Offset",
                ...viewportOffset,
                defaultValue: "",
            },
            {
                name: fields.maxVisibleSlides,
                displayName: "Max Visible Slides",
                editorTemplate: "IntegerField",
                defaultValue: 1,
                fieldType: "Contextual",
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 0,
            },
            {
                name: fields.numberOfItems,
                displayName: "Number of Items",
                editorTemplate: "IntegerField",
                defaultValue: 3,
                fieldType: "Contextual",
                sortOrder: 1,
            },
            ...carouselFieldDefinitions,
        ],
    },
};

export default widgetModule;
